export const handleChangeReportConfig = (state, payload) => {
    let reportSettingsForLogo = {}
    if (payload.isCircumplexLogo) {
        if (payload.values.fileDisplayRawData === null) {
            reportSettingsForLogo = {
                ...state.reportSetupConfig,
                [payload.key]: {
                    ...state.reportSetupConfig[payload.key],
                    logoUrl: null
                },
            }
        }
        return {
            ...state,
            reportSetupConfig: { ...state.reportSetupConfig, ...reportSettingsForLogo },
            fileListData: {
                ...payload.values
            }
        }
    }

    else {
    return {
        ...state,
        reportSetupConfig: {
            ...state.reportSetupConfig,
            [payload.key]: {
                ...state.reportSetupConfig[payload.key],
                ...payload.values
            },

        }
    }
}


}
